import React, { useState } from "react";
import cn from "classnames";
import style from "./index.module.scss";

const CustomTextarea = ({
  onChangeValue = () => void 0,
  isDisabled = false,
  isBgGray = false,
  value = "",
  placeholder = "",
  labelText = "",
  errorText = "",
  rows = 2,
  maxLength = "",
  resize = "vertical",
}) => {
  const [isFocused, setIsFocused] = useState(false);

  const getValue = (event) => {
    onChangeValue(event.target.value);
  };

  return (
    <div style={{ width: "100%" }}>
      <div className={style.wrapper}>
        <label
          className={cn(style.labelInp, {
            [style.focusedLabel]: isFocused,
            [style.labelError]: errorText,
          })}
        >
          {labelText}
        </label>
        <textarea
          className={cn(style.textarea, {
            [style.textarea_disabled]: isDisabled,
            [style.textarea_bg_wgray]: isBgGray,
            [style.textarea_errorState]: errorText,
          })}
          style={{ resize }}
          rows={rows}
          value={value}
          placeholder={placeholder}
          onChange={getValue}
          onFocus={() => setIsFocused(true)}
          onBlur={() => setIsFocused(false)}
          disabled={isDisabled}
          readOnly={isDisabled}
          maxLength={maxLength || undefined}
        />
      </div>
      {errorText && <div className={style.errorText}>{errorText}</div>}
    </div>
  );
};

export default CustomTextarea;
